/**
 * The permission codes the Reconciliation Exceptions screen reads
 * (`internal/bankrec/permissions.go`, FT8-B11). Kept in their own file so the
 * route table can import them without pulling the generated client into the
 * router's bundle.
 *
 * - `bankrec.exception.read` — `GET /reconciliations/exceptions`,
 *   `GET /reconciliation-exceptions/{id}` and `GET /reports/bankrec-dashboard`.
 * - `bankrec.exception.manage` — assign, investigate and resolve. It is also
 *   what an exception's owner must hold.
 */
export const RECON_EXCEPTION_PERMISSIONS = {
  read: 'bankrec.exception.read',
  manage: 'bankrec.exception.manage',
  /** Follow an account to its reconciliation sessions. */
  sessionRead: 'bankrec.session.read',
  /** Name the bank accounts in the filter and the rows. */
  bankAccountRead: 'cash.account.read',
  /** Name the legal entities in the filter. */
  companyRead: 'org.company.read',
  /** Open the journal behind a ledger-side exception. */
  journalRead: 'gl.journal.read',
} as const
